import { render, staticRenderFns } from "./businessCardVideo.vue?vue&type=template&id=214dfa85&scoped=true&"
import script from "./businessCardVideo.vue?vue&type=script&lang=js&"
export * from "./businessCardVideo.vue?vue&type=script&lang=js&"
import style0 from "./businessCardVideo.vue?vue&type=style&index=0&id=214dfa85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214dfa85",
  null
  
)

export default component.exports